import { ISignedDocumentResponse } from "@wingspanhq/signed-documents/dist/lib/interfaces";
import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { ContextItem } from "../../../../types";

export const getSignatureRequirementName = (
  requirement: IRequirementResponse,
  context: ContextItem,
  signedDocument: ISignedDocumentResponse | undefined
) => {
  if (requirement.name) {
    return requirement.name;
  }

  if (!signedDocument) {
    return "--";
  }

  return signedDocument.title;
};
